import { request } from '../client'

import type {
  BrowseGiveawayItemsParams,
  CreateGiveawayRequest,
  CreateGiveawayResponse,
  GiveawayPrizeBrowseResponse,
  GiveawaysResponse,
  JoinGiveawayResponse,
} from '@/services/models/giveaways'
import type { GiveawayRoundResponse } from '@/services/models/response'

export async function getGiveaways() {
  return request<GiveawaysResponse>({
    method: 'GET',
    url: '/v1/giveaways',
  })
}

export async function getGiveawayDetails(roundId: string) {
  return request<GiveawayRoundResponse>({
    method: 'GET',
    url: `/v1/giveaways/${roundId}`,
  })
}

export async function joinGiveaway(roundId: string) {
  return request<JoinGiveawayResponse>({
    method: 'POST',
    url: `/v1/giveaways/${roundId}/join`,
  })
}

export async function browseGiveawayItems(params: BrowseGiveawayItemsParams = {}) {
  return request<GiveawayPrizeBrowseResponse>({
    method: 'GET',
    url: '/v1/giveaways/items',
    params,
  })
}

export async function createGiveaway(data: CreateGiveawayRequest) {
  return request<CreateGiveawayResponse, CreateGiveawayRequest>({
    method: 'POST',
    url: '/v1/giveaways',
    data,
  })
}
